const comments = [
  {
    name: '星光追梦人',
    text: '终于找到一个不用注册就能免费看综艺的平台了！画质超清晰，而且真的不卡顿，每天晚上追偶像团体综艺的最佳选择。',
    time: '2小时前',
    likes: 128,
  },
  {
    name: '综艺达人小王',
    text: '更新速度太给力了！热门真人秀播完没多久就能在这里看到高清全集，再也不用到处找了，已经推荐给身边所有追星的朋友。',
    time: '5小时前',
    likes: 96,
  },
  {
    name: '春日暖阳',
    text: '手机端和电脑端都能流畅播放，通勤路上用手机看选秀节目，回家用电脑看大屏综艺，体验都非常好，1080P真的绝了。',
    time: '8小时前',
    likes: 73,
  },
  {
    name: '追光者小陈',
    text: '从选秀到户外真人秀，从偶像团体到旅行综艺，这里的内容真的太全了！而且完全免费，不缓冲不卡顿，已经成为我的追综第一站。',
    time: '1天前',
    likes: 51,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
          观众热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          来自爱豆影视观众的真实反馈
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg border border-background-200/70 p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-semibold text-primary-600">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.name}</h3>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.text}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}